import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Accordion, Table } from "react-bootstrap";
import bannerImage from "../../Images/academic/mooc-banner.webp";
import swayam from "../../Images/academic/SWAYAM.webp";
import MBA from "../../Images/PDF/MBA MOOC Syllabus.pdf";
import BBA from "../../Images/PDF/BBA MOOC Syllabus.pdf";
import BCom from "../../Images/PDF/BCom MOOC Syllabus.pdf";

import { Link } from "react-router-dom";

const MOOCPage = () => {
  return (
    <>
      <title>10 Years of Empowering Learners with ISBM University MOOC's</title>
      <meta
        name="description"
        content="ISBM University pioneers accessible, high-quality MOOC's, equipping learners with future-ready skills through expert-led, flexible, and interactive online courses."
      />
      <link
        rel="canonical"
        href="https://isbmuniversity.edu.in/pay-fees-online"
      />
      <meta
        name="SearchEngines"
        content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
      />
      <meta name="Robots" content="INDEX, FOLLOW" />
      <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
      <meta name="Robots" content="INDEX,ALL" />
      <meta name="YahooSeeker" content="INDEX, FOLLOW" />
      <meta name="msnbot" content="INDEX, FOLLOW" />
      <meta name="googlebot" content="Default, follow" />
      <meta name="owner" content="isbmuniversity.edu.in/" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="2 days" />
      <meta
        property="og:title"
        content="ISBM University Free Online Courses | SWAYAM | UGC Credit"
      />
      <meta
        property="og:description"
        content="Upskill yourself with ISBM University diverse free online courses. Find the perfect MOOC, learn from renowned professors, and boost your professional profile."
      />
      <meta
        property="og:url"
        content="https://isbmuniversity.edu.in/pay-fees-online/"
      />
      <meta
        property="og:image"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta property="og:image:alt" content="ISBM University" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ISBM University" />
      <meta
        name="twitter:title"
        content="ISBM University Free Online Courses | SWAYAM | UGC Credit"
      />
      <meta
        name="twitter:description"
        content="Upskill yourself with ISBM University diverse free online courses. Find the perfect MOOC, learn from renowned professors, and boost your professional profile."
      />
      <meta
        name="twitter:image:src"
        content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
      />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@ISBMUniversity" />
      <meta name="twitter:creator" content="@ISBMUniversity" />
      <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
      <meta property="twitter:account_id" content="758619542734053376" />
      <meta
        name="keywords"
        content="free online courses, swayam, Best Online Learning platforms"
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Massive Open Online Courses (MOOC's)</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  MOOC's
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          {/* About SWAYAM Section */}
          <Row className="justify-content-center mb-5">
            <Row className="align-items-center flex-lg-row-reverse">
              <Col lg={2} className="p-0 order-lg-2">
                <div className="partner-logo-container h-100">
                  <img
                    src={swayam}
                    alt="Swayam Free Online Education Logo"
                    className="object-fit-cover h-100 w-100"
                  />
                </div>
              </Col>
              <Col lg={10} className="p-4 ">
                <div className="partner-content">
                  <h4 className="modern-title section-title-start text-blue">
                    About SWAYAM
                  </h4>
                  <p>
                    As per the UGC (Credit Framework for online learning courses
                    through SWAYAM) Regulation 2016, ISBM University introduces
                    MOOC's courses through SWAYAM platform of Government of India
                    for the benefit of the students.
                  </p>
                  <p>
                    SWAYAM (Study Web of Active Learning by Young and Aspiring
                    Minds) is a program initiated by Government of India and
                    designed to achieve access, equity, and quality. SWAYAM
                    platform is indigenously developed by Ministry of Human
                    Resource Development (MHRD) and All India Council for
                    Technical Education (AICTE). The objective of this effort is
                    to take the best teaching-learning resources to all,
                    including the most disadvantaged. SWAYAM seeks to bridge the
                    digital divide for students who have remained untouched by
                    the digital revolution. This is done through an indigenous
                    developed IT Platform that facilitates hosting of all the
                    courses taught in classrooms to be accessed by anyone,
                    anywhere at any time. All the courses are interactive and
                    are available free of cost to the residents in India.
                  </p>
                </div>
              </Col>
            </Row>
          </Row>
        </div>
      </section>

      <section className="ptb-50 bg-light">
        <div className="container-xxl">
          {/* Quadrants Section */}
          <Row>
            <Col lg={12}>
              <div className="quadrants-section ">
                <h2 className="modern-title section-title-start text-blue">
                  Quadrants of MOOC's
                </h2>
                <p>
                  These Massive Open Online Courses (MOOC's) hosted on SWAYAM
                  will be in 4 quadrants.
                </p>
                <Row className="g-4 mt-3">
                  {[
                    {
                      title: "Video Lecture",
                      icon: "ti-video",
                    },
                    {
                      title:
                        "Specially prepared reading material that can be downloaded/Printed",
                      icon: "ti-book",
                    },
                    {
                      title: "Self Assessment Tests",
                      icon: "ti-checklist",
                    },
                    {
                      title: "An Online Discussion forum for clearing doubts",
                      icon: "ti-message-circle",
                    },
                  ].map((quadrant, index) => (
                    <Col md={6} lg={3} key={index}>
                      <div className="common-card bg-white p-3 rounded-3 shadow-sm h-100">
                        <div className="common-card-icon bg-blue rounded-circle d-flex align-items-center justify-content-center mb-3 mx-auto">
                          <i
                            className={`ti ${quadrant.icon} text-light fs-3`}
                          ></i>
                        </div>
                        <h4 className="h5 text-center">{quadrant.title}</h4>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="ptb-50">
        <div className="container-xxl">
          {/* National Coordinators */}
          <Row>
            <Col lg={12}>
              <div className="coordinators-section">
                <h2 className="text-blue modern-title section-title-start">
                  National Coordinators for MOOC's
                </h2>
                <p>
                  Seven National Coordinators have been appointed to start the
                  MOOC's as:
                </p>
                <ul className="styled-list two-column">
                  <li>NPTEL for Engineering</li>
                  <li>UGC for Post Graduation Education</li>
                  <li>CEC for Under Graduate Education</li>
                  <li>NCERT for School Education</li>
                  <li>NIOS for School Education</li>
                  <li>IGNOU for out of the school students</li>
                  <li>IIMB for Management studies</li>
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="ptb-50 bg-light">
        <div className="container-xxl">
          {/* Course Delivery */}
          <Row>
            <Col lg={12}>
              <div className="delivery-section ">
                <h2 className="text-blue modern-title section-title-start">
                  Course Delivery & Certification
                </h2>
                <p>
                  Courses delivered through SWAYAM are available free of cost to
                  the learners, however, students wanting certifications shall
                  be registered and shall be offered a certificate of successful
                  completion of the course with a little fee. At the end of each
                  course, there will be an assessment of the student through
                  proctored examination and the marks/grades secured in this
                  examination could be transferred to the academic record of the
                  students.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="ptb-50 ">
        <div className="container-xxl">
          {/* Additional Resources */}
          <Row>
            <Col lg={12}>
              <div className="resources-section">
                <p className="lead">
                  The following are the courses identified by ISBM University to
                  be offered through SWAYAM along with the proposed academic
                  program and semester in which courses to be offered.
                </p>
                <Row className="g-4">
                  {[
                    {
                      title: "e PG Pathshala",
                      link: "https://epgp.inflibnet.ac.in",
                      description: "UGC's platform for postgraduate education",
                    },
                    {
                      title: "e Pathshala",
                      link: "https://epathshala.nic.in",
                      description: "NCERT's digital learning resources",
                    },
                    {
                      title: "SWAYAM MOOC",
                      link: "https://swayam.gov.in/",
                      description: "Official SWAYAM platform",
                    },
                    {
                      title: "Padhai Tunhar Dwar",
                      link: "http://cgschool.in/Default.aspx",
                      description: "Chhattisgarh's digital learning initiative",
                    },
                  ].map((resource, index) => (
                    <Col md={6} lg={3} key={index}>
                      <div className="common-card bg-white p-3 h-100 rounded-3 shadow">
                        <h4 className="h5 mb-2">{resource.title}</h4>
                        <p className="small text-muted mb-2">
                          {resource.description}
                        </p>
                        <a
                          href={resource.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-outline-purple"
                        >
                          Visit Portal
                        </a>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="ptb-50 bg-light">
        <div className="container-xxl">
          {/* Courses by School */}
          <Row>
            <Col lg={12}>
              <h2 className="text-blue modern-title section-title-start">
                Courses Offered :
              </h2>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <i className="ti ti-settings fs-3 me-2 text-blue"></i>
                    <h5 className="text-blue mb-0">
                      School of Engineering and Technology
                    </h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="table-responsive text-center">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th width="10%">Sr.No.</th>
                            <th width="60%">Course Name</th>
                            <th width="30%">Web Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              NOC:Infrared spectroscopy for pollution monitoring
                            </td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/103108139/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/103108139/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              NOC:Environmental Engineering-Chemical Processes
                            </td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/105107176/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/105107176/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>NOC:Electrical Distribution System Analysis</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/108107112/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/108107112/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>NOC:Facts Devices</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/108107114/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/108107114/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              NOC:Advanced Linear Continuous Control Systems:
                              Applications with MATLAB Programming and Simulink
                            </td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/108107115/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/108107115/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>NOC:Semiconductor Devices and Circuits</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/108108112/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/108108112/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>
                              NOC:Fabrication Techniques for MEMs-based sensors
                              : clinical perspective
                            </td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/108108113/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/108108113/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              Advanced Control System Design for Aerospace
                              Vehicles
                            </td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/101108047/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/101108047/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>Advanced Electric Drives</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/108104011/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/108104011/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>Advanced Engineering Mathematics</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/111105035/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/111105035/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>11</td>
                            <td>Advanced Finite Elements Analysis</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/112106130/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/112106130/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>12</td>
                            <td>Advanced Foundation Engineering</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/105108069/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/105108069/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>13</td>
                            <td>Advanced Chemical Reaction Engineering (PG)</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/103101001/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/103101001/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>14</td>
                            <td>Advanced Gas Dynamics</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/112106056/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/112106056/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>15</td>
                            <td>Advanced Geotechnical Engineering</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/105101001/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/105101001/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>16</td>
                            <td>Advanced Heat and Mass Transfer</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/103105052/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/103105052/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>17</td>
                            <td>Advanced Hydrology</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/105103021/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/105103021/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>18</td>
                            <td>Advanced Logic Synthesis</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/117106109/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/117106109/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>19</td>
                            <td>Advanced Machining Processes</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/112104028/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/112104028/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>20</td>
                            <td>
                              Advanced manufacturing process for micro system
                              fabrication
                            </td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/112104162/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/112104162/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>21</td>
                            <td>Advanced Manufacturing Processes</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/112107077/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/112107077/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>22</td>
                            <td>Advanced Marine Structures</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/114106037/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/114106037/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>23</td>
                            <td>
                              Advanced Mathematical Techniques in Chemical
                              Engineering
                            </td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/103105106/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/103105106/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>24</td>
                            <td>Advanced Numerical Analysis</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/103101009/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/103101009/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>25</td>
                            <td>Advanced Operations Research</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/112106131/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/112106131/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>26</td>
                            <td>Advanced Optical Communication</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/117101002/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/117101002/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>27</td>
                            <td>Advanced Process Control</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/103101003/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/103101003/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>28</td>
                            <td>Advanced Solid Mechanics</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/105106049/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/105106049/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>29</td>
                            <td>Advanced Strength of Materials</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/112101095/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/112101095/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>30</td>
                            <td>Advanced Structural Analysis</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/105106050/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/105106050/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>31</td>
                            <td>
                              Advanced Techniques in Geotechnical and Foundation
                              Engineering
                            </td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/105106144/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/105106144/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>32</td>
                            <td>Advanced Transport Phenomena</td>
                            <td>
                              <u>
                                <a
                                  href="http://nptel.ac.in/courses/103106068/"
                                  target="_blank"
                                >
                                  http://nptel.ac.in/courses/103106068/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>33</td>
                            <td>ANALOG ELECTRONIC CIRCUITS</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102095/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102095/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>34</td>
                            <td>Applied mechanics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/122102004/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/122102004/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>35</td>
                            <td>Automation &amp; Controls</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112102011/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112102011/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>36</td>
                            <td>Circuit Theory</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102042/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102042/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>37</td>
                            <td>
                              Civil Engineering - Building materials and
                              Construction
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105102088/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105102088/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>38</td>
                            <td>Communication Engineering</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117102059/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117102059/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>39</td>
                            <td>Computational Geometry</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102011/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102011/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>40</td>
                            <td>Computer Aided Design and Manufacturing</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112102101/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112102101/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>41</td>
                            <td>Computer Aided Design and Manufacturing I</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112102102/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112102102/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>42</td>
                            <td>Computer Aided Design and Manufacturing II</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112102103/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112102103/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>43</td>
                            <td>Computer Architecture</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102062/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102062/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>44</td>
                            <td>Computer Graphics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102063/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102063/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>45</td>
                            <td>Concrete Technology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105102012/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105102012/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>46</td>
                            <td>Control Engineering</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102043/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102043/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>47</td>
                            <td>Data Structures And Algorithms</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102064/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102064/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>48</td>
                            <td>DIGITAL COMMUNICATION</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102096/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102096/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>49</td>
                            <td>Digital Signal Processing</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117102060/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117102060/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>50</td>
                            <td>Electronics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/115102014/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/115102014/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>51</td>
                            <td>Environment and Ecology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/122102006/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/122102006/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>52</td>
                            <td>Embedded Systems</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102045/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102045/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>53</td>
                            <td>Enzyme Science and Engineering</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/102102033/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/102102033/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>54</td>
                            <td>Environmental Air Pollution</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105102089/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105102089/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>55</td>
                            <td>Fabric Manufacture - I</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102005/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102005/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>56</td>
                            <td>Fuel Cell Technology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/103102015/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/103102015/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>57</td>
                            <td>G.I.S in Civil Engineering</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105102015/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105102015/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>58</td>
                            <td>High Performance and Specialty Fibres</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102006/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102006/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>59</td>
                            <td>Industrial Drives</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102046/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102046/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>60</td>
                            <td>Introduction to Computer Graphics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102065/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102065/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>61</td>
                            <td>Introduction To Electronic Circuits</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102097/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102097/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>62</td>
                            <td>
                              Introduction to Problem Solving and Programming
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102066/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102066/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>63</td>
                            <td>Knitting Technology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102066/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102066/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>64</td>
                            <td>Kinematics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102008/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102008/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>65</td>
                            <td>
                              Heterogeneous Catalysis and Catalytic Processes
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112102105/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112102105/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>66</td>
                            <td>Linear Algebra</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111102011/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111102011/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>67</td>
                            <td>Logic for CS</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102013/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102013/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>68</td>
                            <td>Manufactured Fibre Technology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102010/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102010/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>69</td>
                            <td>Mechanics of Solids</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105102090/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105102090/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>70</td>
                            <td>Mechanics of Textile Machinery</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102012/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102012/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>71</td>
                            <td>
                              Nano structured materials-synthesis, properties,
                              self assembly and applications
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/118102003/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/118102003/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>72</td>
                            <td>NOC:Analog Electronic Circuit</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102112/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102112/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>73</td>
                            <td>NOC:Computer Architecture</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102157/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102157/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>74</td>
                            <td>
                              NOC:Energy Efficiency, Acoustics and daylighting
                              in Building
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105102175/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105102175/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>75</td>
                            <td>
                              NOC:Fire Protection, Services and Maintenance
                              Management of Building
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105102176/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105102176/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>76</td>
                            <td>
                              NOC:Geoenvironmental Engineering (Environmental
                              Geotechnology): Landfills, Slurry Ponds &amp;
                              Contaminated Sites
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105102160/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105102160/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>77</td>
                            <td>
                              NOC:Information Theory, Coding and Cryptography
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102117/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102117/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>78</td>
                            <td>
                              NOC:Introduction to Materials Science and
                              Engineering
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/113102080/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/113102080/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>79</td>
                            <td>
                              NOC:Introduction to Parallel Programming in OpenMP
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102163/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102163/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>80</td>
                            <td>
                              NOC:Introduction to Probability Theory and
                              Stochastic Processes
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111102111/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111102111/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>81</td>
                            <td>NOC:Nonlinear and Adaptive Control</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102113/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102113/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>82</td>
                            <td>NOC:RAC Product Design</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112102248/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112102248/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>83</td>
                            <td>NOC:Science of Clothing Comfort</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102047/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102047/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>84</td>
                            <td>NOC:Semiconductor Optoelectronics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/115102103/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/115102103/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>85</td>
                            <td>NOC:Statistical Inference</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111102112/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111102112/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>86</td>
                            <td>Power System Dynamics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102080/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102080/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>87</td>
                            <td>
                              Power System Generation, Transmission and
                              Distribution (Encapsulated from earlier Video)
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108102047/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108102047/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>88</td>
                            <td>Principles of Programming Languages</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106102067/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106102067/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>89</td>
                            <td>Project and Production Management</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112102107/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112102107/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>90</td>
                            <td>Quality Control in Textile Industry</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102019/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102019/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>91</td>
                            <td>Quantum Electronics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/115102022/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/115102022/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>92</td>
                            <td>Quantum Mechanics and Applications</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/115102023/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/115102023/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>93</td>
                            <td>Restructured Power Systems</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108101005/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108101005/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>94</td>
                            <td>RF Integrated Circuits</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117102012/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117102012/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>95</td>
                            <td>Seismic Analysis of Structures</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105102016/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105102016/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>96</td>
                            <td>
                              Textile Chemical Processing: Theory and practice
                              of Preparatory Processes
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102016/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102016/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>97</td>
                            <td>Semiconductor Optoelectronics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/115102026/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/115102026/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>98</td>
                            <td>Shuttleless Weaving</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102017/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102017/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>99</td>
                            <td>Stochastic Processes</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111102014/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111102014/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>100</td>
                            <td>Textile Fibres</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102026/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102026/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>101</td>
                            <td>Textile Testing</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102029/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102029/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>102</td>
                            <td>Theory of Yarn Structures</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/116102034/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/116102034/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>103</td>
                            <td>Transport Phenomena (UG)</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/103102024/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/103102024/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>104</td>
                            <td>Tribology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112102015/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112102015/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>105</td>
                            <td>Semiconductor Devices</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117102061/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117102061/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>106</td>
                            <td>Structure and Functions of Biomolecules</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104102016/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104102016/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>107</td>
                            <td>
                              Advanced Complex Analysis - Part 2: Compactness of
                              Meromorphic Functions in the Spherical Metric,
                              Spherical Derivative, Normality, Theorems of
                              Marty-Zalcman-Montel-Picard-Royden-Schottky
                              Syllabus
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111106094/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111106094/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>108</td>
                            <td>CMOS Analog VLSI Design</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117101105/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117101105/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>109</td>
                            <td>Advanced Control Systems</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108103007/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108103007/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>110</td>
                            <td>Acoustics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112104026/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112104026/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>111</td>
                            <td>Adaptive Signal Processing</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117101001/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117101001/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>112</td>
                            <td>
                              Adv. Digital Signal Processing - Multirate and
                              wavelets
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104104066/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104104066/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>113</td>
                            <td>Advance Analytical Course</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117104099/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117104099/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>114</td>
                            <td>
                              Advanced 3G and 4G Wireless Mobile Communications
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111105069/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111105069/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>115</td>
                            <td>A Basic Course in Real Analysis</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111102009/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111102009/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>116</td>
                            <td>Advanced Antenna Theory</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/113105015/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/113105015/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>117</td>
                            <td>
                              Advanced ceramics for strategic applications
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112103016/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112103016/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>118</td>
                            <td>Advanced Engineering Thermodynamics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112103016/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112103016/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>119</td>
                            <td>Advanced Hydraulics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105103021/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105103021/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>120</td>
                            <td>Advanced Statistical Mechanics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/115103028/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/115103028/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>121</td>
                            <td>Basic Biology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/122103039/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/122103039/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>122</td>
                            <td>Basic Electronics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117103063/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117103063/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>123</td>
                            <td>Basic Organic Chemistry</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104103071/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104103071/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>124</td>
                            <td>Bio-organic chemistry</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104103018/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104103018/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>125</td>
                            <td>
                              Bio-Organic Chemistry of Natural Enediyne
                              Anticancer Antibiotics
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104103068/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104103068/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>126</td>
                            <td>Bioanalytical Techniques and Bioinformatics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/102103044/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/102103044/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>127</td>
                            <td>Catalyst Science and Technology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/103103026/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/103103026/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>128</td>
                            <td>Catalytic Asymmetric Synthesis</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104103067/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104103067/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>129</td>
                            <td>
                              Acoustic Instabilities in Aerospace Propulsion
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/101106031/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/101106031/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>130</td>
                            <td>Chemical Engineering Design - II</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/103103027/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/103103027/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>131</td>
                            <td>Chemical Technology - II</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/103103029/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/103103029/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>132</td>
                            <td>Chemistry of Materials</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104103019/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104103019/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>133</td>
                            <td>Complex Analysis</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111103070/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111103070/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>134</td>
                            <td>
                              Computational Number Theory &amp; Cryptography
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106103015/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106103015/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>135</td>
                            <td>Computer Organization and Architecture</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106103068/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106103068/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>136</td>
                            <td>Construction Economics &amp; Finance</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105103023/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105103023/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>137</td>
                            <td>Construction Planning and Management</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105103093/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105103093/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>138</td>
                            <td>Continuum Mechanics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112103167/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112103167/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>139</td>
                            <td>Cell Biology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/102103012/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/102103012/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>140</td>
                            <td>Cellular and Molecular Immunology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/102103038/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/102103038/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>141</td>
                            <td>Characterization of Materials</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/115103030/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/115103030/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>142</td>
                            <td>Data Structures and Program Methodology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106103069/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106103069/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>143</td>
                            <td>Design for Manufacture and Assembly(DFMA)</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106103069/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106103069/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>144</td>
                            <td>Design fundamentals</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/107103012/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/107103012/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>145</td>
                            <td>
                              Design Verification and Test of Digital VLSI
                              Circuits
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/107103002/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/107103002/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>146</td>
                            <td>Digital Circuits</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106103116/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106103116/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>147</td>
                            <td>Digital Control System</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117103064/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117103064/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>148</td>
                            <td>Electromagnetic Fields</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108103008/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108103008/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>149</td>
                            <td>Engineering Drawing</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117103065/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117103065/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>150</td>
                            <td>Engineering Mechanics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112103108/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112103108/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>151</td>
                            <td>Cultural Studies</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/109103018/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/109103018/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>152</td>
                            <td>Basic Thermodynamics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112104113/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112104113/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>153</td>
                            <td>Biomicroelectromechanical systems</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112104029/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112104029/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>154</td>
                            <td>Color in Design</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/109104075/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/109104075/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>155</td>
                            <td>Compiler Design</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106104072/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106104072/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>156</td>
                            <td>Composite Materials and Structures</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/101104010/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/101104010/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>157</td>
                            <td>
                              Computational Fluid Dynamics and Heat Transfer
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112104030/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112104030/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>158</td>
                            <td>Computer Aided Engineering Design</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112104031/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112104031/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>159</td>
                            <td>Computer Algorithms - 2</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106104019/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106104019/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>160</td>
                            <td>Computer Organisation and Architecture</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106104073/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106104073/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>161</td>
                            <td>Concrete Engineering and Technology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105104030/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105104030/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>162</td>
                            <td>Convective Heat and Mass Transfer</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112104159/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112104159/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>163</td>
                            <td>Convex Optimization</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111104068/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111104068/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>164</td>
                            <td>
                              Design Paradigm: Source Of Innovation &amp;
                              Invention
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/107104076/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/107104076/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>165</td>
                            <td>Design Philosophy &amp; History</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/107104078/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/107104078/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>166</td>
                            <td>Digital Image Processing</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117104069/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117104069/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>167</td>
                            <td>Digital Switching</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117104069/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117104069/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>168</td>
                            <td>Digital Video Signal Processing</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117104020/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117104020/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>169</td>
                            <td>Discrete Mathematics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111104026/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111104026/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>170</td>
                            <td>Dynamics of Machines</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112104114/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112104114/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>171</td>
                            <td>Engine Combustion</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/122104014/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/122104014/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>172</td>
                            <td>Engineering Physics II</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105104099/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105104099/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>173</td>
                            <td>Ethics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112104115/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112104115/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>174</td>
                            <td>
                              Exploring Human Values: Visions of Happiness and
                              Perfect Society
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112104116/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112104116/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>175</td>
                            <td>Finite Element Method</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112104172/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112104172/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>176</td>
                            <td>Fluid Machinery</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/101104013/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/101104013/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>177</td>
                            <td>Fuel,furnace and Refractory</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/113104058/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/113104058/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>178</td>
                            <td>Fundamentals of Combustion</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/101104014/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/101104014/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>179</td>
                            <td>High Speed Semiconductor Devices</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117104071/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117104071/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>180</td>
                            <td>High Voltage DC Transmission</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108104013/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108104013/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>181</td>
                            <td>Game Theory for Economists</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/109104034/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/109104034/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>182</td>
                            <td>Aircraft Structural Dynamics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/101105022/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/101105022/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>183</td>
                            <td>Applied Multivariate Statistical Modeling</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/110105060/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/110105060/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>184</td>
                            <td>Applied Thermodynamics for Marine Systems</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/114105029/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/114105029/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>185</td>
                            <td>Artificial Intelligence</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106105077/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106105077/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>186</td>
                            <td>Advanced Materials and Processes</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/113105057/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/113105057/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>187</td>
                            <td>Biocatalysis in organic synthesis</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104105032/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104105032/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>188</td>
                            <td>Biochemical Engineering</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/103105054/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/103105054/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>189</td>
                            <td>Chaos, Fractals &amp; Dynamic Systems</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108105054/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108105054/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>190</td>
                            <td>
                              Co-ordination chemistry (chemistry of transition
                              elements)
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104105033/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104105033/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>191</td>
                            <td>Bio-inorganic chemistry</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104105031/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104105031/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>192</td>
                            <td>Artificial Intelligence(Prof.P.Dasgupta)</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106105079/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106105079/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>193</td>
                            <td>Communication Networks and Switching</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117105076/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117105076/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>194</td>
                            <td>Astrophysics &amp; Cosmology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/115105046/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/115105046/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>195</td>
                            <td>Computational Fluid Dynamics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112105045/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112105045/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>196</td>
                            <td>Computer Networks</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106105080/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106105080/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>197</td>
                            <td>Data Communication</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106105082/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106105082/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>198</td>
                            <td>Design of Concrete Structures</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105105104/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105105104/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>199</td>
                            <td>Design of Machine Elements I</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112105124/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112105124/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>200</td>
                            <td>Design of Reinforced Concrete Structures</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105105105/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105105105/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>201</td>
                            <td>Consumer Behaviour</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/110105029/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/110105029/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>202</td>
                            <td>Cryptography and Network Security</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106105031/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106105031/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>203</td>
                            <td>Digital Computer Organization</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117105078/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117105078/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>204</td>
                            <td>Electrical Machines -I</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108105017/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108105017/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>205</td>
                            <td>Electronic Design Automation</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106105083/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106105083/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>206</td>
                            <td>Digital Voice &amp; Picture Communication</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117105081/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117105081/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>207</td>
                            <td>Dynamics of Physical Systems</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108105056/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108105056/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>208</td>
                            <td>Digital Systems Design</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117105080/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117105080/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>209</td>
                            <td>Elements of Ocean Engineering</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/114105002/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/114105002/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>210</td>
                            <td>Engineering Geology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105105106/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105105106/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>211</td>
                            <td>Estimation of Signals and Systems</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108105059/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108105059/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>212</td>
                            <td>Finite Element Analysis</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105105041/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105105041/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>213</td>
                            <td>Fuel and Combustion Technology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/103105110/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/103105110/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>214</td>
                            <td>Fundamental Algorithms:Design and Analysis</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106105157/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106105157/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>215</td>
                            <td>
                              Fundamentals of Environmental Pollution and
                              Control
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/123105001/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/123105001/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>216</td>
                            <td>Energy Resources &amp; Technology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108105058/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108105058/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>217</td>
                            <td>
                              Fundamentals of Industrial Oil Hydraulics and
                              Pneumatics
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112105047/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112105047/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>218</td>
                            <td>Fluid Mechanics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/112105171/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/112105171/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>219</td>
                            <td>Ground Water Hydrology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105105042/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105105042/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>220</td>
                            <td>High Performance Computer Architecture</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/106105033/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/106105033/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>221</td>
                            <td>High Speed Aero Dynamics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/101105024/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/101105024/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>222</td>
                            <td>Hydrostatics and Stability</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/114105003/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/114105003/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>223</td>
                            <td>Illumination Engineering</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108105060/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108105060/
                                </a>
                              </u>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <i className="ti ti-briefcase me-2 fs-3 text-blue"></i>
                    <h5 className="text-blue mb-0">
                      School of Management &amp; Commerce
                    </h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="table-responsive text-center">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th width="10%">Sr.No.</th>
                            <th width="60%">Course Name</th>
                            <th width="30%">Web Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Econometric Modelling</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108105055/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108105055/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Economics / Management / Entrepreneurship</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/110105067/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/110105067/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Master Of Business Administration</td>
                            <td>
                              <u>
                                <a href={MBA} target="_blank">
                                  Click for Syllabus
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>Bachelor's of Commerce (Honours)</td>
                            <td>
                              <u>
                                <a href={BCom} target="_blank">
                                  Click for Syllabus
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>Bachelor of Business Administration</td>
                            <td>
                              <u>
                                <a href={BBA} target="_blank">
                                  Click for Syllabus
                                </a>
                              </u>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <i className="ti ti-flask me-2 fs-3 text-blue"></i>
                    <h5 className="text-blue mb-0">School of Science</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="table-responsive text-center">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th width="10%">Sr.No.</th>
                            <th width="60%">Course Name</th>
                            <th width="30%">Web Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Materials Science</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/122102008/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/122102008/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Fundamental concepts of semiconductors</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/115102025/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/115102025/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Linear Programming Problems</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111102012/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111102012/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>Advanced Abstract Algebra</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/117107035/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/117107035/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              Plasma Physics: Fundamentals and Applications
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/115102020/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/115102020/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>NOC:Chaotic Dynamical Systems</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111102110/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111102110/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>Management Science I</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/122102007/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/122102007/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>
                              Advanced Complex Analysis - Part 2: Compactness of
                              Meromorphic Functions in the Spherical Metric,
                              Spherical Derivative, Normality, Theorems of
                              Marty-Zalcman-Montel-Picard-Royden-Schottky
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111106094/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111106094/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>Biological Bases of Behavior</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/109104029/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/109104029/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>
                              Analysis of variance and design of experiment-II
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111104078/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111104078/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>11</td>
                            <td>Animal Physiology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/102104042/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/102104042/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>12</td>
                            <td>Applied Multivariate Analysis</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111104024/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111104024/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>13</td>
                            <td>
                              Astronomy in Ancient, Medieval and Early
                              Telescopic Era of India
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/121104006/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/121104006/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>14</td>
                            <td>Advanced Characterization Techniques</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/105104029/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/105104029/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>15</td>
                            <td>
                              Calculus of Variations and Integral Equations
                            </td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111104025/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111104025/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>16</td>
                            <td>Communication Skills</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/109104031/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/109104031/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>17</td>
                            <td>Econometric Theory</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111104072/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111104072/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>18</td>
                            <td>Environmental Degradation of Materials</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/109104068/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/109104068/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>19</td>
                            <td>Electroceramics</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/122104015/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/122104015/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>20</td>
                            <td>Foundations of Optimization</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111104071/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111104071/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>21</td>
                            <td>BioChemistry I</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/102105034/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/102105034/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>22</td>
                            <td>Basic Electrical Technology</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/108105053/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/108105053/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>23</td>
                            <td>Functional Analysis</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/111105037/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/111105037/
                                </a>
                              </u>
                            </td>
                          </tr>
                          <tr>
                            <td>24</td>
                            <td>Heterocyclic Chemistry</td>
                            <td>
                              <u>
                                <a
                                  href="https://nptel.ac.in/courses/104105034/"
                                  target="_blank"
                                >
                                  https://nptel.ac.in/courses/104105034/
                                </a>
                              </u>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default MOOCPage;
